import Cookies from 'js-cookie';

const ANNOUNCEMENT_COOKIES_KEY = 'larts';

export default {
  data() {
    return {
      larts: new Date().now,
    }
  },
  mounted() {
    this.larts = this.getLarts();
  },
  methods: {
    getLarts() {
      return parseInt(Cookies.get(ANNOUNCEMENT_COOKIES_KEY), 10) || 0;
    },
    updateLarts: function() {
      const announcements = this.announcements || [];
      this.larts = this.announcements.reduce((m, { issuedTime = 0} = {}) => {
        return issuedTime > m ? issuedTime : m;
      }, this.larts);
      Cookies.set(ANNOUNCEMENT_COOKIES_KEY, this.larts, { expires: 90 });
    },
  }
}